import script from "./HiddenTokensPills.vue?vue&type=script&setup=true&lang=ts"
export * from "./HiddenTokensPills.vue?vue&type=script&setup=true&lang=ts"

import "./HiddenTokensPills.vue?vue&type=style&index=0&id=8169d09c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8169d09c"]])

export default __exports__